import { render } from "./UserLevelPermissions.vue?vue&type=template&id=60db5c1a"
import script from "./UserLevelPermissions.vue?vue&type=script&lang=js"
export * from "./UserLevelPermissions.vue?vue&type=script&lang=js"

import "./UserLevelPermissions.vue?vue&type=style&index=0&id=60db5c1a&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__